import React from "react";

export const Root = ({ children }: { children: React.ReactNode }) => (
  <>{children}</>
);

// Export children
export { Income } from "./Income";
export { Population } from "./Population";
export { Housing } from "./Housing";
export { Household } from "./Household";
export { Education } from "./Education";
export { Commute } from "./Commute";
export { Languages } from "./Languages";
